import { EntityLayout } from '@backstage/plugin-catalog'
import { overviewContent } from './overviewContent';
import { isTechDocsAvailable } from '@backstage/plugin-techdocs';
import { techdocsContent } from './techdocsContent';

export type ResourceEntityPageProps = {
  overview?: React.JSX.Element;
  additionalRoutes?: React.JSX.Element;
}

export const resourceEntityPage = (props?: ResourceEntityPageProps) => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {props?.overview ?? overviewContent()}
    </EntityLayout.Route>

    {props?.additionalRoutes}

    <EntityLayout.Route path="/docs" title="Docs" if={isTechDocsAvailable}>
      {techdocsContent()}
    </EntityLayout.Route>
  </EntityLayout>
);
